import BookingPage from "./BookingPage";
export default function ContactEnquiry() { return <BookingPage type="contact" />; }
